import Modal from 'react-bootstrap/Modal';
import { HotTable } from '@handsontable/react';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useAuth } from 'react-oidc-context';

import { Box, Button, CircularProgress, ListItem, ListItemButton, ListItemText, styled } from '@mui/material';
import { Form } from 'react-bootstrap';
import { SnackbarContext } from '../../App';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export default ({ fetchData, show, onHide, abn, name, taxAgentNumber }) => {
  const auth = useAuth();

  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, sessionExpired, setSessionExpired } = useContext(SnackbarContext);

  const [
    tan,
    setTan,
  ] = useState(taxAgentNumber);

  const [
    isLoading,
    setIsLoading,
  ] = useState(false);

  const [
    buttonDisable,
    setButtonDisable,
  ] = useState(true);

  useEffect(() => {
    setButtonDisable(false);
  }, [tan]);

  useEffect(() => {
    setTan(taxAgentNumber);
  }, [taxAgentNumber]);

  async function updateTan() {
    if (taxAgentNumber == tan) {
      setSnackBarMessage('No change applied');
      setSnackBarShow(true);
      return;
    }

    const response = await fetch(`${window.origin}/api/setup/tan`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
      body: JSON.stringify({
        tan: tan,
      }),
    });

    if (response.status === 403) {
      setSessionExpired(true);
      throw new Error('Session expired');
    }

    setSnackBarMessage('Tax agent number updated');
    setSnackBarShow(true);

    fetchData();

    if (!response.ok) {
      throw new Error('Network response was not ok ' + response.statusText);
    }
  }

  return (

    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="modal-50w"
      aria-labelledby="example-custom-modal-styling-title"
    >

      <Modal.Body style={{ padding: '2vw 3vw', textAlign: 'center', color: 'rgb(0, 15, 30, 0.7)' }}>

        <h4 style={{ textAlign: 'center', fontSize: '1.3vw', marginBottom: '2vw', fontWeight: '600' }}>Company Details</h4>

        <p style={{ margin: 0, marginBottom: '2.5vw', fontWeight: '300', fontSize: '0.8vw', padding: '0 2vw', color: 'rgb(0, 15, 30, 0.7)' }}>Please ensure the provided tax agent number is correct and valid</p>

        {isLoading && <CircularProgress style={{ marginBottom: '1vw', color: 'white' }} />}

        {!isLoading && (
          <div>
            <Form.Group style={{ marginBottom: '2vw', flex: 1, textAlign: 'left' }}>
              <p style={{ fontSize: '0.9vw', marginBottom: '0.5vw' }}>Australian Business Number</p>
              <Form.Control style={{ height: '3vw', backgroundColor: 'rgba(254, 254, 255,.5)', border: 'none', borderRadius: '0.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw' }} type="text" placeholder="ABN" value={abn} disabled />
            </Form.Group>
            <Form.Group style={{ marginBottom: '2vw', flex: 1, textAlign: 'left' }}>
              <p style={{ fontSize: '0.9vw', marginBottom: '0.5vw' }}>Company Name</p>
              <Form.Control autocomplete="new-password" style={{ height: '3vw', backgroundColor: 'rgba(254, 254, 255,.5)', border: 'none', borderRadius: '0.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw' }} type="text" value={name} disabled />
            </Form.Group>
            <Form.Group style={{ marginBottom: '2vw', flex: 1, textAlign: 'left' }}>
              <p style={{ fontSize: '0.9vw', marginBottom: '0.5vw' }}>Tax Agent Number</p>
              <Form.Control style={{ height: '3vw', backgroundColor: 'rgba(254, 254, 255,.5)', border: 'none', borderRadius: '0.5vw', fontSize: '0.8vw', paddingLeft: '0.8vw' }} type="text" placeholder="Tax Agent Number" value={tan} onChange={e => setTan(e.target.value)} />
            </Form.Group>

            <Button
              onClick={updateTan}
              variant="outlined"
              style={{
                borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.7vw', marginBottom: '1vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
                width: '100%', marginTop: '1vw' }}
            >
              Save
            </Button>
          </div>
        )}

      </Modal.Body>
    </Modal>
  );
};


